/* Slider behaviour for horizontal scrollers, plus a swipeable product gallery.
   Progressive enhancement - everything still scrolls without this file. */
(function () {
  'use strict';

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function icon(dir) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M' +
           (dir === 'prev' ? '15 6 9 12l6 6' : '9 6 6 6-6 6') + '"/></svg>';
  }

  function initScroller(scroller) {
    if (scroller.dataset.wrCarouselReady) return;
    var items = $$(':scope > *', scroller).filter(function (el) {
      return !el.classList.contains('wr-dots');
    });
    if (items.length < 2) return;
    scroller.dataset.wrCarouselReady = '1';

    var wrap = scroller.closest('.wr-carousel');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'wr-carousel';
      scroller.parentNode.insertBefore(wrap, scroller);
      wrap.appendChild(scroller);
    }

    var dots = wrap.querySelector('[data-wr-dots], .wr-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'wr-dots';
      dots.setAttribute('data-wr-dots', '');
      wrap.appendChild(dots);
    }

    dots.innerHTML = '';
    var buttons = items.map(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      b.addEventListener('click', function () { scrollToItem(i); });
      dots.appendChild(b);
      return b;
    });

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.className = 'wr-carousel__arrow wr-carousel__arrow--prev';
    next.className = 'wr-carousel__arrow wr-carousel__arrow--next';
    prev.type = next.type = 'button';
    prev.setAttribute('aria-label', 'Previous');
    next.setAttribute('aria-label', 'Next');
    prev.innerHTML = icon('prev');
    next.innerHTML = icon('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function scrollToItem(i) {
      var target = items[Math.max(0, Math.min(items.length - 1, i))];
      if (target) scroller.scrollTo({ left: target.offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
    }

    function current() {
      var mid = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      items.forEach(function (item, i) {
        var c = item.offsetLeft - items[0].offsetLeft + item.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function sync() {
      var i = current();
      buttons.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      var max = scroller.scrollWidth - scroller.clientWidth;
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max - 2;
      wrap.classList.toggle('is-scrollable', max > 4);
    }

    prev.addEventListener('click', function () { scrollToItem(current() - 1); });
    next.addEventListener('click', function () { scrollToItem(current() + 1); });

    var tick;
    scroller.addEventListener('scroll', function () {
      window.cancelAnimationFrame(tick);
      tick = window.requestAnimationFrame(sync);
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function init() {
    $$('.wr-scroller').forEach(initScroller);

    $$('[data-wr-gallery]').forEach(function (gallery) {
      if (gallery.dataset.wrGalleryReady) return;
      var main = gallery.querySelector('.wr-gallery__main');
      var slides = $$('.wr-gallery__slide', gallery);
      var thumbs = $$('.wr-gallery__thumb', gallery);
      if (!main || slides.length < 2) return;
      gallery.dataset.wrGalleryReady = '1';

      main.classList.add('is-swipe');
      slides.forEach(function (s) { s.classList.add('is-active'); });

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          main.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        });
      });

      var tick;
      main.addEventListener('scroll', function () {
        window.cancelAnimationFrame(tick);
        tick = window.requestAnimationFrame(function () {
          var mid = main.scrollLeft + main.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          slides.forEach(function (s, i) {
            var c = s.offsetLeft - slides[0].offsetLeft + s.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === best); });
        });
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
